import React from "react";
import { useDispatch } from "react-redux";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { deleteUserLoyaltyProgram } from "Bands/state";

const { userLoyaltyProgram: loyaltyCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserLoyaltyProgramModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserLoyaltyProgram(id));
  };

  return (
    <DeleteUserEntityModal
      type="loyalty program"
      action={USER_ACTIONS.deleteUserLoyaltyProgram}
      successMessage={loyaltyCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
